module.exports = "/assets/9007d86e28841884a122559fbd8501e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AB.png
// module id = 2318
// module chunks = 0